module.exports = __webpack_public_path__ + "static/img/rank_156.5bbdc9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_156.png
// module id = Dx6w
// module chunks = 1